export default __webpack_public_path__ + "static/media/bg_vid.04eea3e8.mp4";